<template>
  <div class="TimUi-media">
    <video controlsList='nodownload noremote footbar' v-if="mediaType==='video'" :src="crruentMediaObj.goodsChildFilePath" ref="video" @pause="onPause" @play="onPlay" @ended="onEnded" controls="controls">
      Your browser does not support the video element.
    </video>
    <audio controlsList="nodownload" v-else :src="crruentMediaObj.goodsChildFilePath" ref="audio" @pause="onPause" @play="onPlay" @ended="onEnded" @canplay="getDuration" @timeupdate="updateTime">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>

export default {
  name: 'TimUiMedia',
  props: {
    crruentMediaObj: {
      type: Object,
      required: true
    },
    mediaType: {
      type: String,
      required: true
    }
    // arr: {
    //   type: Array,
    //   required: true // 必传
    // },
    // str: String,
    // num: [String, Number], // 两个类型都可以传
    // bol: {
    //   type: Boolean,
    //   default: false // 默认false
    // }
  },
  data () {
    return {
      'autoplay': true,
      'preload': 'none', // "none" | "metadata" | "auto" | ""
      'controls': 'controls', // "controls" | "" 是否需要显示控件
      'loop': 'loop', // "loop" or "" 是否循环播放
      'mediagroup': '', // string 多个视频或者音频流是否合并
      'src': '',
      media: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        duration: 0, // 媒体时长 秒
        currentTime: 0 // 当前播放时间 秒
      }
    }
  },
  created () { },
  mounted () { },
  watch: {
    'media.currentTime': function (n, o) {
      const thisObj = this
      let nSecond = Math.floor(n)
      let oSecond = Math.floor(o)
      if (nSecond !== oSecond) {
        thisObj.sendCurrentTime(nSecond)
      }
    }
  },
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause () {
      return this.media.playing ? this.pause() : this.play()
    },
    // 播放音频
    play () {
      const thisObj = this
      if (thisObj.mediaType === 'video') {
        thisObj.$refs.video.play()
      } else {
        thisObj.$refs.audio.play()
      }
    },
    // 暂停音频
    pause () {
      if (this.mediaType === 'video') {
        this.$refs.video.pause()
      } else {
        this.$refs.audio.pause()
      }
    },
    // 当音频播放
    onPlay () {
      const thisObj = this
      thisObj.$emit('nativeControl', thisObj.crruentMediaObj.goodsChildId, 'play')
      thisObj.updateTime()
      thisObj.media.playing = true
    },
    // 当音频暂停
    onPause () {
      const thisObj = this
      thisObj.$emit('nativeControl', thisObj.crruentMediaObj.goodsChildId, 'pause')
      thisObj.media.playing = false
    },
    // 重新播放(音频暂停,回到开始时间)
    onReplay () {
      const thisObj = this
      thisObj.onPause()
      if (this.mediaType === 'video') {
        thisObj.$refs.video.currentTime = 0
      } else {
        thisObj.$refs.audio.currentTime = 0
      }
      setTimeout(function () {
        thisObj.play()
      }, 100)
    },
    // 播放结束
    onEnded () {
      const thisObj = this
      thisObj.onPause()
      if (this.mediaType === 'video') {
        thisObj.$refs.video.currentTime = 0
      } else {
        thisObj.$refs.audio.currentTime = 0
      }
      thisObj.$emit('overPlay', thisObj.crruentMediaObj.goodsChildId)
    },
    // 此时可以获取到duration
    getDuration () {
      this.media.duration = this.$refs.audio.duration
    },
    // 获取audio当前播放时间
    updateTime (e) {
      if (e !== undefined) {
        this.media.currentTime = e.target.currentTime // 获取audio当前播放时间
      }
    },
    // 发送当前播放时间
    sendCurrentTime (t) {
      const thisObj = this
      let totalSecond = thisObj.media.duration
      this.$emit('updateTime', t, totalSecond)
    },
    setCrruntTime (t) {
      const thisObj = this
      thisObj.$refs.audio.currentTime = t
      if (thisObj.media.playing) {
        thisObj.play()
      } else {
        thisObj.pause()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.TimUi-media,
.TimUi-media video {
  width: 100%;
}
</style>
